var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"instButton instApplyButton",attrs:{"type":"button"},on:{"click":_vm.goTo}},[_vm._v("Подать заявку")])
}
var staticRenderFns = []

export { render, staticRenderFns }